export const FILTER_ANY_VALUE = '###ANY###';
export const FILTER_EMPTY_VALUE = '###EMPTY###';

export const getFilterTypeByName = (name) => {
    if (name === null || name === undefined) {
        return 'text';
    }
    switch (name.toLowerCase()) {
        case 'createddate':
        case 'actualdeliverydate':
        case 'actualdeparturedate':
        case 'deliverydate':
        case 'departuredate':
        case 'statuschangedat':
        case 'receiveddate':
        case 'lastissuedeadline':
            return 'date';
        case 'parceltype':
        case 'shipmenttype':
        case 'source':
        case 'issuestatus':
            return 'select';
        case 'status':
            return 'status';
        case 'weight':
        case 'actualweight':
        case 'costprice':
        case 'volume':
        case 'volumeweight':
        case 'deliverycost':
        case 'actualdeliverycost':
        case 'tariffrate':
            return 'numberRange';
        case 'shipmentregion':
        case 'deliveryregion':
        case 'carrier':
        case 'carrierservicename':
        case 'company':
        case 'companyus':
        case 'costcenter':
        case 'deliverytype':
        case 'additionalservicesshortnames':
            return 'selectMultiple';
        case 'shipmentpoint':
        case 'shipmentaddress':
        case 'deliverypoint':
        case 'deliveryaddress':
        case 'number':
        case 'recipientname':
        case 'sendername':
        case 'comment':
        case 'receiptlocation':
        case 'creatorname':
        case 'parcelstatuscomment':
            return 'text';
        case 'carrierreviewcomment':
            return 'textCustom';
        case 'lastissuesolvedintime':
            return 'bool';
        default:
            return 'text';
    }
}

export const nameForUrl = (name) => {
    switch (name) {
        default:
            return name;
    }
}

export const sortIsOn = (name) => {
    if (name === null || name === undefined) {
        return false;
    }
    const sortFields = [
        'createddate',
        'weight',
        'actualweight',
        'costprice',
        'volume',
        'volumeweight',
        'deliverycost',
        'actualdeliverycost',
        'tariffrate',
        'actualdeliverydate',
        'actualdeparturedate',
        'deliverydate',
        'departuredate',
    ]
    return sortFields.includes(name.toLowerCase());
}

export const unitName = (name) => {
    if (name === null || name === undefined) {
        return null;
    }
    switch (name.toLowerCase()) {
        case 'weight':
        case 'actualweight':
        case 'volumeweight':
            return 'кг';
        case 'costprice':
        case 'deliverycost':
        case 'actualdeliverycost':
            return '₽';
        case 'volume':
            return 'м³';
        default: return null;
    }
}

export const settingsWithoutThis = (filterParams, name) => {
    let filtersData = (({...(filterParams.settings || {})}).filters || []).filter(v => v.fieldName !== name);
    return {
        settings: {
            filters: filtersData,
            order: (filterParams.settings || {}).order
        }
    }
}


// WEBPACK FOOTER //
// ./App/grids/utils.js